import { Schema } from "effect";
import { WorkspaceView } from "./workspace-view.ts";
import { SavePhase } from "./pending-model.ts";

export const WorkspaceHydration = Schema.Struct({
  sequence: Schema.Int, workspaceId: Schema.String,
  previousWorkspaceId: Schema.NullOr(Schema.String), view: WorkspaceView
});
export type WorkspaceHydration = typeof WorkspaceHydration.Type;
export const StationWorkbenchSnapshot = Schema.Struct({
  stationId: Schema.NullOr(Schema.String), workspaces: Schema.Array(Schema.String),
  activeWorkspace: Schema.NullOr(Schema.String), workspaceId: Schema.NullOr(Schema.String),
  draft: WorkspaceView, phase: SavePhase, booted: Schema.Boolean,
  bootstrapError: Schema.NullOr(Schema.String), showLauncher: Schema.Boolean,
  hydration: Schema.NullOr(WorkspaceHydration), navigationSequence: Schema.Int,
  freshPreviewSequence: Schema.Int, closed: Schema.Boolean
});
export type StationWorkbenchSnapshot = typeof StationWorkbenchSnapshot.Type;
export const initialStationWorkbench = (draft: WorkspaceView): StationWorkbenchSnapshot => ({
  stationId: null, workspaces: [], activeWorkspace: null, workspaceId: null, draft,
  phase: "idle", booted: false, bootstrapError: null, showLauncher: false,
  hydration: null, navigationSequence: 0, freshPreviewSequence: 0, closed: false
});
export const StationRoute = Schema.Union([
  Schema.Struct({ _tag: Schema.tag("Station"), stationId: Schema.String }),
  Schema.Struct({ _tag: Schema.tag("Launcher") }),
  Schema.Struct({ _tag: Schema.tag("Fresh") })
]);
export type StationRoute = typeof StationRoute.Type;
